<template>
    <div>
        <b-row v-if="purchase.contract || purchase.actions.customer.contract !== 'disallow'">
            <b-col class="d-flex justify-content-between align-items-center">
                <text-header id="atmo-contract" class="atmo-hash-jump-point">Контракт</text-header>
            </b-col>
        </b-row>
        <fl44-unknown-volume-purchase-contract-info v-if="purchase.contract" :purchase="purchase" @refresh="refresh($event)" />
        <private-fl44-unknown-volume-contract-customer-block v-if="$store.getters.isLoggedIn && purchase.is_customer && purchase.actions.customer.contract !== 'disallow'" :purchase="purchase" @refresh="refresh($event)" />
        <private-fl44-unknown-volume-contract-supplier-block v-if="$store.getters.isLoggedIn && purchase.is_supplier && purchase.actions.supplier.contract !== 'disallow'" :purchase="purchase" @refresh="refresh(null)" />
        <fl44-unknown-volume-supplementary-agreement-block v-if="purchase.flags.has_contract && purchase.contract" :purchase="purchase" @refresh="refresh($event)" />
    </div>
</template>

<script>
import PrivateFl44UnknownVolumeContractCustomerBlock from '@/components/products/fl44-unknown-volume/partials/private-fl44-unknown-volume-contract-customer-block.vue';
import Fl44UnknownVolumePurchaseContractInfo from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-purchase-contract-info.vue';
import Fl44UnknownVolumeSupplementaryAgreementBlock from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplementary-agreement-block.vue';
import PrivateFl44UnknownVolumeContractSupplierBlock from '@/components/products/fl44-unknown-volume/partials/private-fl44-unknown-volume-contract-supplier-block.vue';

export default {
    name: 'fl44-unknown-volume-contract-block',
    components: {
        PrivateFl44UnknownVolumeContractSupplierBlock,
        Fl44UnknownVolumeSupplementaryAgreementBlock,
        Fl44UnknownVolumePurchaseContractInfo,
        PrivateFl44UnknownVolumeContractCustomerBlock
    },
    props: {
        purchase: {
            type: Object,
            required: true
        },
    },
    methods: {
        refresh(newHash = null) {
            this.$emit('refresh', newHash);
        }
    }
};
</script>
